// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:26:36
import { PersistentObject } from '../../../SagaBase/PersistentObject';
import * as SagaBase from '../../../SagaBase';
import { Guid, GuidTools } from '@models/guid';

export abstract class RbacUserRole_abstract extends PersistentObject {
  static $t: string = 'SagaBase.RBAC.RbacUserRole';
  $t: string = 'SagaBase.RBAC.RbacUserRole';

  public static GetMembers(): string[] {
    return ['UserId', 'UserRoleId', 'RoleId', 'RoleName', 'RoleDescription'].concat(PersistentObject.GetMembers());
  }

  public GetMembers(): string[] {
    return RbacUserRole_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public UserId: number = 0;
  public UserRoleId: number = 0;
  public RoleId: number = 0;
  public RoleName: string;
  public RoleDescription: string;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  get ObjId(): any {
    return this.RoleId;
  }
  get ParentObjId(): any {
    return this.UserId;
  }
  set ParentObjId(value: any) {
    this.UserId = value;
  }

  /*</AUTO_IMPLEMENTATION>*/
}
